


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const addServicesTypeReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.ADD_SERVICES_TYPE_HERE:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.ADD_SERVICES_TYPE_HERE_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.ADD_SERVICES_TYPE_HERE_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
